import { StateCreator } from 'zustand'

import type { StoreState } from '..'
import { CommonDialogProps, DialogConfig } from '@/features/dialogs/common/types'

export interface DialogSlice<P = {}> {
  dialogs: {
    openedDialog?: {
      config: DialogConfig<P & CommonDialogProps>
      props: P
    }
    openDialog: (config: DialogConfig<P & CommonDialogProps>, props: P) => void
    closeDialog: () => void
  }
}

// eslint-disable-next-line func-style
export const initDialogSlice: StateCreator<StoreState, [], [], DialogSlice> = (set) => ({
  dialogs: {
    openedDialog: undefined,
    openDialog: (config, props) => {
      set((state) => ({ dialogs: { ...state.dialogs, openedDialog: { config, props } } }))
    },
    closeDialog: () => {
      set((state) => ({ dialogs: { ...state.dialogs, openedDialog: undefined } }))
    },
  },
})

export type OpenDialogFunction = <P>(dialog: DialogConfig<P & CommonDialogProps>, props: P) => void
